export const LOGIN_POPUP_VISIBILITY = "LOGIN_POPUP_VISIBILITY";
export const LOGIN_POPUP_HIDE_AND_CLEAR = "LOGIN_POPUP_HIDE_AND_CLEAR";

/**
 * 
 * @param {*}
 * @returns 
 * 
 * Sets login popup visibility and add callback if it is a function object
 */
export function changePopupVisibility(status, callback) {
 
  return (dispatch) => {
    dispatch({
      type: LOGIN_POPUP_VISIBILITY,
      payload: {
        status,
        callback: callback, 
      },
    });
  };
}
/**
 * 
 * Hide login popup and clear callback list  
 */
export function hidePopupAndClearCallbacks() {
 
  return (dispatch) => {
    dispatch({
      type: LOGIN_POPUP_HIDE_AND_CLEAR,
      payload: {},
    });
  };
}